module.exports = __webpack_public_path__ + "img/springs-ballet.333993e0.png";